module.exports = __webpack_public_path__ + "static/media/mh_entrium_05.da49a025.png";